import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const Moment = require('moment');
//import DatePicker from 'react-datepicker';
import { Row, Button } from 'react-bootstrap';
const isArray = require('lodash/isArray');

const Strings = require('../../../../app/shared/Strings');
const ProjectStore = require('../../stores/ProjectStore');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const ServerRequest = require('../../actions/request');
import TimeseriesChart from '../chart/TimeseriesChart';
import { ChartTotalsBoxRow, ChartTotalsBox, ChartTotalsBoxItem } from '../chart/ChartTotalsBox';
import AccessibleDatePicker from '../common/AccessibleDatePicker';

const propTypes = {
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

const defaultProps = {};

class ProjectOverviewRangeChart extends React.Component {
    constructor(props) {
        super(props);

        let projectId = parseInt(props.projectId, 10);

        this.pollTaskManager = new ServerRequest.PollTaskManager();

        this.state = {
            analyticsStoreState: AnalyticsStore.getState(),
            projectStoreState: ProjectStore.getStateProject(projectId),
            startDate: this.getStartDate(Moment().subtract(1, 'M').toDate(), ProjectStore.getStateProject(projectId)),
            endDate: new Date(),
            selectedDate: null,
            getOverviewRangeId: null
        };

        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onDateSelect = this.onDateSelect.bind(this);
        this.getOverviewRange = this.getOverviewRange.bind(this);
        this.onOverviewRangeUpdate = this.onOverviewRangeUpdate.bind(this);

        this.unsubscribes = [
            AnalyticsStore.listen(this.onStoreChange.bind(this, 'analyticsStoreState')),
            ProjectStore.listen(this.onProjectStoreStateChange.bind(this))
        ];
    }

    componentDidUpdate(prevProps) {
        if (this.props.projectId !== prevProps.projectId) {
            const overviewAnalyticsRange = this.state.analyticsStoreState.projectOverviewAnalyticsRange[this.props.projectId];
            if (!!overviewAnalyticsRange && isArray(overviewAnalyticsRange.timeseriesCol) && overviewAnalyticsRange.timeseriesCol.length > 0) {
                this.setState({
                    startDate: Moment(overviewAnalyticsRange.timeseriesCol[1]).toDate(),
                    endDate: Moment(overviewAnalyticsRange.timeseriesCol[overviewAnalyticsRange.timeseriesCol.length-1]).toDate(),
                });
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        this.pollTaskManager.abandonTasks();
    }

    onStoreChange(storeStateName, state) {
        let additionalState = {};
        if (state.action.id === this.state.getOverviewRangeId) {
            additionalState.getOverviewRangeId = null;
        }
        this.setState({ [storeStateName]: state, ...additionalState });
    }

    onProjectStoreStateChange(state) {
        let additionalState = {};
        let projectStoreState = ProjectStore.getStateProject(parseInt(this.props.projectId, 10));
        if (!this.state.projectStoreState.initialized && state.initialized) { //just became initialized
            additionalState = { ...additionalState, startDate: this.getStartDate(this.state.startDate, projectStoreState) };
        }

        this.setState({ projectStoreState: projectStoreState, ...additionalState });
    }

    getStartDate(currentStartDate, projectStoreState) { // if current start date is earlier than the project creation date, return project creation date (Date)
        if (projectStoreState.initialized) {
            let projectCreateDate = Moment(projectStoreState.project.created_at).toDate();
            if (currentStartDate < projectCreateDate) {
                return projectCreateDate;
            }
        }

        return currentStartDate;
    }

    onStartDateChange(date) {
        this.setState({ startDate: date });
    }

    onEndDateChange(date) {
        this.setState({ endDate: date });
    }

    onDateSelect(newDate) {
        this.setState({ selectedDate: newDate });
    }

    getOverviewRange(projectId) {
        const getOverviewRangeId = uuid.v4();
        if (this.state.getOverviewRangeId) {
            this.pollTaskManager.cancelAction(this.state.getOverviewRangeId);
        }
        this.setState({ getOverviewRangeId: getOverviewRangeId }, () => {
            AnalyticsActions.getProjectOverviewRange(
                getOverviewRangeId, 
                { id: projectId, startDate: Moment(this.state.startDate), endDate: Moment(this.state.endDate) },
                this.pollTaskManager
            )
        });
    }

    onOverviewRangeUpdate(e) {
        this.getOverviewRange(this.props.projectId);
    }

    render() {
        const overviewAnalyticsRange = this.state.analyticsStoreState.projectOverviewAnalyticsRange[this.props.projectId];
        if (!this.state.projectStoreState.initialized) {
            return null;
        }

        function _oar_total(arr) {
            var t=0;
            for (var i=1; i<arr.length; ++i) {
                t += arr[i];
            }
            return t;
        }

        return (
            <div>
                <Row className="margin-bottom-lg">
                    <div className="col-12 col-sm-5 margin-bottom-sm">
                        <label className="label-form margin-right-sm" htmlFor="ml-porc-start">
                            {Strings['en'].common.START_DATE}
                        </label>
                        <AccessibleDatePicker
                            id="ml-porc-start"
                            className="margin-right-md"
                            selected={this.state.startDate}
                            onChange={this.onStartDateChange}
                            minDate={Moment(this.state.projectStoreState.project.created_at).toDate()}
                            maxDate={this.state.maxDate}
                        />
                    </div>
                    <div className="col-12 col-sm-5 margin-bottom-sm">
                        <label className="label-form margin-right-sm" htmlFor="ml-porc-end">
                            {Strings['en'].common.END_DATE}
                        </label>
                        <AccessibleDatePicker
                            id="ml-porc-end"
                            className="margin-right-md"
                            selected={this.state.endDate}
                            onChange={this.onEndDateChange}
                            minDate={this.state.startDate}
                            maxDate={new Date()}
                        />
                    </div>
                    <div className="col-12 col-sm-2 margin-bottom-sm">
                        <Button
                            disabled={!!this.state.getOverviewRangeId}
                            onClick={this.onOverviewRangeUpdate}
                        >
                            {Strings['en'].common.UPDATE}
                        </Button>
                    </div>
                </Row>
                {(!!overviewAnalyticsRange) ?
                    <div className="margin-bottom-lg">
                        <TimeseriesChart
                            id="stats-range-chart"
                            height={300}
                            labelShow={false}
                            legendShow
                            yInt
                            columns={[overviewAnalyticsRange.timeseriesCol, overviewAnalyticsRange.assignmentsCol, overviewAnalyticsRange.attemptsCol, overviewAnalyticsRange.activeStudentsCol]}
                        />
                        <ChartTotalsBoxRow>
                            <ChartTotalsBox title="Totals" className="chart-totals-wide margin-bottom-lg">
                                <ChartTotalsBoxItem label={overviewAnalyticsRange.assignmentsCol[0]} value={_oar_total(overviewAnalyticsRange.assignmentsCol)} />
                                {(typeof overviewAnalyticsRange.nonEmptyAssnCount === 'number') &&
                                    <ChartTotalsBoxItem label={Strings['en'].analytics.COUNT_NON_EMPTY_ASSN} value={overviewAnalyticsRange.nonEmptyAssnCount} />
                                }
                                <ChartTotalsBoxItem label={overviewAnalyticsRange.attemptsCol[0]} value={_oar_total(overviewAnalyticsRange.attemptsCol)} />
                                <ChartTotalsBoxItem label={overviewAnalyticsRange.activeStudentsCol[0]} value={overviewAnalyticsRange.activeStudentsTotal} />
                            </ChartTotalsBox>
                        </ChartTotalsBoxRow>
                    </div>
                    :
                    <div className="margin-bottom-xl font-style-italic text-center">
                        {Strings['en'].analytics.overview.assignment_stats.UPDATE_PROMPT}
                    </div>
                }
            </div>
        )
    }
}

ProjectOverviewRangeChart.propTypes = propTypes;
ProjectOverviewRangeChart.defaultProps = defaultProps;

export default ProjectOverviewRangeChart;
